import React from 'react';
import { ZapIcon, ArrowRightIcon, LockIcon, RefreshCwIcon, StarIcon, CheckCircleIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-cream py-10 px-4" data-id="element-279">
      <div className="max-w-[600px] mx-auto text-center" data-id="element-280">
        {/* Main Headline */}
        <h1 className="text-[28px] sm:text-[32px] leading-[1.3] font-bold text-brand-black mb-4" data-id="element-281">
          <ZapIcon className="inline-block w-8 h-8 text-primary mb-1 mr-2" data-id="element-282" />
          Domina los Comandos Eléctricos en 24 Horas™
        </h1>

        {/* Subtitle */}
        <p className="text-dark-gray text-base sm:text-lg leading-relaxed mb-6 max-w-[500px] mx-auto" data-id="element-283">
          Aprende a leer diagramas, montar tableros y trabajar con seguridad con
          una guía visual paso a paso de 370 páginas + simulación + herramientas
          profesionales
        </p>

        {/* Product Image */}
        <div className="mb-8 mx-auto max-w-[500px]" data-id="element-284">
          <img src="https://cdn.magicpatterns.com/uploads/oTG63tToJqGPpUVcKnsGwh/imagen_principal.png" alt="Domina los Comandos Eléctricos" className="w-full h-auto block drop-shadow-2xl" width="500" height="500" data-id="element-285" />
        </div>

        {/* CTA */}
        <a href="https://dominaelcontrol.online/cart/50664044626153:1" onClick={() => window.fbq && window.fbq('track', 'AddToCart')} className="animate-pulse-big flex items-center justify-center gap-2 max-w-[400px] mx-auto bg-gradient-to-br from-success to-emerald-600 text-white border-none py-4 px-6 text-lg font-bold rounded-full cursor-pointer shadow-[0_8px_20px_rgba(34,197,94,0.3)] text-center uppercase tracking-wide no-underline mb-4 hover:translate-y-[-3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(34,197,94,0.4)] transition-all duration-400" data-id="element-286">
          QUIERO DOMINAR LOS COMANDOS ELÉCTRICOS
          <ArrowRightIcon className="w-5 h-5" data-id="element-287" />
        </a>

        {/* Trust Badges */}
        <div className="flex flex-col items-center gap-2 mt-4 text-sm text-dark-gray font-medium" data-id="element-288">
          <div className="flex items-center gap-3" data-id="element-289">
            <span className="flex items-center gap-1" data-id="element-290">
              <LockIcon className="w-4 h-4 text-primary" data-id="element-291" /> Garantía 7 Días
            </span>
            <span data-id="element-292">·</span>
            <span className="flex items-center gap-1" data-id="element-293">
              <ZapIcon className="w-4 h-4 text-primary" data-id="element-294" /> Acceso Inmediato
            </span>
          </div>
          <div className="flex items-center gap-1" data-id="element-295">
            <RefreshCwIcon className="w-4 h-4 text-primary" data-id="element-296" /> Actualizaciones
            diarias de por vida
          </div>
          <div className="bg-[#1A1D24] border border-white/10 rounded-full px-4 py-1.5 flex items-center gap-2 mt-1" data-id="element-297">
            <div className="flex text-primary" data-id="element-298">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-299" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-300" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-301" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-302" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-303" />
            </div>
            <span className="text-white font-bold text-xs" data-id="element-304">
              4.9/5{' '}
              <span className="text-dark-gray font-normal" data-id="element-305">
                +2.554 Electricistas
              </span>
            </span>
            <CheckCircleIcon className="w-4 h-4 text-blue-500 fill-white" data-id="element-306" />
          </div>
        </div>
      </div>
    </section>;
}